import { flow, types } from 'mobx-state-tree'
import { generateOTP } from '../../network/DomesticMoneyTransfer/LoginReq'
import { validateOtpApi } from '../../network/DomesticMoneyTransfer/validateOtpApi'
import { authenticateOtp, getAuthenticateOtpForCustomer } from '../../network/authenticateOtp'
import {
  executeTransaction,
  getBalanceRequest,
  getFundTransferReq,
  getNextActionRequest,
  method,
} from '../../network/executeTransaction'
import {
  fetchParticularTransaction,
  getParticularTransactionRequest,
  transactionStatusParser,
} from '../../network/fetchParticularTransaction'
import { fetchTransactionHistory, getTransactionHistoryRequest } from '../../network/fetchTransactionHistory'
import { generateOtp, getAadhaarOtpRequest, getOtpRequest } from '../../network/generateOtp'
import { getLinkAadhaarOtpRequest, linkAadhaarOtp, refreshUserSession } from '../../network/linkAadhaarWithOtp'
import { JIO_PAYMENT_BANK_BIN } from '../../util/utill'
import { RootStore } from '../store'
import { Session } from './Session'

const Balance = types.model('Balance', {
  bankId: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  aadhaarNumber: types.optional(types.string, ''),
  amount: types.optional(types.string, '0'),
})

const Transaction = types.model('Transaction', {
  transactionType: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  transactionTime: types.optional(types.string, ''),
  transactionDetails: types.optional(types.string, ''),
  transactionId: types.optional(types.string, ''),
})
const TransactionInfo = types.model('TransactionInfo', {
  transactionId: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  customerName: types.optional(types.string, ''),
  mobileNo: types.optional(types.string, ''),
  aadhaarNumber: types.optional(types.string, ''),
  amount: types.optional(types.string, '0'),
  tnxTime: types.optional(types.string, ''),
  message: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  transferType: types.optional(types.string, ''),
  remittersAadhar: types.optional(types.string, ''),
  remittersVID: types.optional(types.string, ''),
  beneficiaryAadhar: types.optional(types.string, ''),
  nextActionRequest: types.optional(types.string, ''),
  rrnNo: types.optional(types.string, ''),
  availableBalance: types.optional(types.string, ''),
})

let MAX_LOCATION_RETRIES = 3
const Customer = types
  .model('Customer', {
    balance: types.maybeNull(Balance),
    aadhaarNo: types.optional(types.string, ''),
    vid: types.optional(types.string, ''),
    bankName: types.optional(types.string, ''),
    transactionTime: types.optional(types.string, ''),
    transactions: types.array(Transaction),
    amount: types.optional(types.string, ''),
    fetchTnxListStatus: types.optional(types.string, ''),
    cashWithdrawal: types.maybeNull(TransactionInfo),
    session: types.optional(Session, {}),
    remittanceUserId: types.optional(types.string, ''),
  })
  .actions((self: any) => ({
    cashWithdrawalOrDepositApi: flow(function* cashWithdrawalOrDepositApi(
      aadhaarNumber: string,
      fingerprintData: string,
      bankId: string,
      bankName: string,
      mobileNo: string,
      amount: string,
      vid,
      consentDetails: any,
      type: 'cash_withdrawal' | 'cash_deposit',
      authorizationCode,
      authMode: any,
    ) {
      try {
        // yield RootStore.agent.getAgentLocationInfo();
        // if (!RootStore.agent.deviceInfo.latitude || !RootStore.agent.deviceInfo.longitude) {
        //   const error = {
        //     message: 'Location data is required for this transaction. Please ensure your device location is enabled and try again.',
        //     code: 'LOCATION_ERROR'
        //   };
        //   RootStore.message.handleError(error);
        //   throw error;
        // }
        // const { latitude, longitude } = yield RootStore.agent.fetchDeviceLocation();
        // const latitude = RootStore.agent.deviceInfo.latitude;
        // const longitude = RootStore.agent.deviceInfo.longitude;
        // console.log(latitude,"fetchedlatandlong:::::",longitude)
        // console.log(latitude,"fetchedlatandlong:::::",longitude)
        yield RootStore.agent.checkLocationWithRetries()
        // while (true) {
        //   yield RootStore.agent.getAgentLocationInfo();
        //   if (RootStore.agent.deviceInfo.latitude && RootStore.agent.deviceInfo.longitude) {
        //     console.log('Location found. Proceeding with transaction.');
        //     break;
        //   }
        //   console.log('Location not available. Retrying...');
        //   yield new Promise(resolve => setTimeout(resolve, 1000));
        // }
        const request: any = getBalanceRequest(
          RootStore.agent.agentInfo,
          fingerprintData,
          aadhaarNumber,
          bankId,
          bankName,
          mobileNo,
          vid,
          type === 'cash_withdrawal' ? method.CASH_WITHDRAWAL : method.CASH_DEPOSIT,
          consentDetails,
          amount,
          authorizationCode,
          RootStore.agent.otpReferenceId
          // latitude,
          // longitude
        )
        request.secure.biometrics.type = authMode === 'FACE' ? 3 : 1
        let res = yield executeTransaction(RootStore.agent.session, request, type)
        console.log(RootStore.agent.otpReferenceId, "RootStore.agent.otpReferenceId:::")
        if (type === 'cash_deposit' && (bankId !== JIO_PAYMENT_BANK_BIN || res?.nextActionRequest)) {
          if (res?.nextActionRequest) {
            const nextActionReq = getNextActionRequest(
              JSON.parse(res?.nextActionRequest),
              aadhaarNumber,
              bankId,
              bankName,
              mobileNo,
              vid,
              consentDetails,
              amount,
            )
            res = yield executeTransaction(RootStore.agent.session, nextActionReq, type)
          }
        }
        self.cashWithdrawal = res
        return res
      } catch (err) {
        if (err?.data?.responseCode != '22413') {
          RootStore.message.handleError(err)
        }
        throw err
      } finally {
        if (RootStore.agent && typeof RootStore.agent.clearOtpReferenceId === 'function') {
          RootStore.agent.clearOtpReferenceId();
        }
      }
    }),
    fundTransferApi: flow(function* fundTransferApi(inputParams: FundTransferApiProps) {
      try {
        // yield RootStore.agent.getAgentLocationInfo();
        // if (!RootStore.agent.deviceInfo.latitude || !RootStore.agent.deviceInfo.longitude) {
        //   const error = {
        //     message: 'Location data is required for this transaction. Please ensure your device location is enabled and try again.',
        //     code: 'LOCATION_ERROR'
        //   };
        //   RootStore.message.handleError(error);
        //   throw error;
        // }
        yield RootStore.agent.checkLocationWithRetries()
        // const { latitude, longitude } = yield RootStore.agent.fetchDeviceLocation();
        // while (true) {
        //   yield RootStore.agent.getAgentLocationInfo();
        //   if (RootStore.agent.deviceInfo.latitude && RootStore.agent.deviceInfo.longitude) {
        //     console.log('Location found. Proceeding with fund transfer.');
        //     break;
        //   }
        //   console.log('Location not available. Retrying...');
        //   yield new Promise(resolve => setTimeout(resolve, 1000));
        // }

        const res = yield executeTransaction(
          RootStore.agent.session,
          getFundTransferReq(RootStore.agent.agentInfo, inputParams),
          'fund_transfer',
        )
        self.cashWithdrawal = res
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getBalanceApi: flow(function* getBalanceApi(
      aadhaarNumber: string,
      bankId: string,
      bankName: string,
      mobileNo: string,
      fingerprintData: any,
      vid: any,
      consentDetails: any,
      authMode: any,
    ) {
      try {
        yield RootStore.agent.checkLocationWithRetries()
        // const { latitude, longitude } = yield RootStore.agent.fetchDeviceLocation();
        // console.log(latitude,"fetchedlatandlong:::::",longitude)
        const balanceRequest: any = getBalanceRequest(
          RootStore.agent.agentInfo,
          fingerprintData,
          aadhaarNumber,
          bankId,
          bankName,
          mobileNo,
          vid,
          method.BALENCE_ENQUIRY_TYPE,
          consentDetails,
          // latitude,
          // longitude
        )
        balanceRequest.secure.biometrics.type = authMode === 'FACE' ? 3 : 1
        const res = yield executeTransaction(RootStore.agent.session, balanceRequest, 'balance_enquiry').catch(
          (err: any) => {
            RootStore.message.handleError(err)
            throw err
          },
        )
        self.cashWithdrawal = res
        return res
      } catch (err) {
        // You may want to handle errors from the location check here
        RootStore.message.handleError(err)
        throw err
      }
    }),
    // getBalanceApi: flow(function* getBalanceApi(
    //   aadhaarNumber: string,
    //   bankId: string,
    //   bankName: string,
    //   mobileNo: string,
    //   fingerprintData: any,
    //   vid: any,
    //   consentDetails: any,
    //   authMode: any,
    // ) {
    //   const balanceRequest: any = getBalanceRequest(
    //     RootStore.agent.agentInfo,
    //     fingerprintData,
    //     aadhaarNumber,
    //     bankId,
    //     bankName,
    //     mobileNo,
    //     vid,
    //     method.BALENCE_ENQUIRY_TYPE,
    //     consentDetails,
    //   )
    //   balanceRequest.secure.biometrics.type = authMode === 'FACE' ? 3 : 1;
    //   const res = yield executeTransaction(
    //     RootStore.agent.session,
    //     balanceRequest,
    //     'balance_enquiry',
    //   ).catch((err: any) => {
    //     RootStore.message.handleError(err)
    //     throw err
    //   })
    //   self.cashWithdrawal = res
    //   return res
    // }),
    getMiniStatementApi: flow(function* getMiniStatementApi(
      aadhaarNumber: string,
      bankId: string,
      bankName: string,
      mobileNo: string,
      fingerPrintData: any,
      vid: any,
      consentDetails: any,
      authMode: any,
    ) {
      try {
        yield RootStore.agent.checkLocationWithRetries()
        const request: any = getBalanceRequest(
          RootStore.agent.agentInfo,
          fingerPrintData,
          aadhaarNumber,
          bankId,
          bankName,
          mobileNo,
          vid,
          method.MINI_STATEMENT_TYPE,
          consentDetails,
        )
        request.secure.biometrics.type = authMode === 'FACE' ? 3 : 1
        const res = yield executeTransaction(RootStore.agent.session, request, 'mini_statement').catch((err: any) => {
          RootStore.message.handleError(err)
          throw err
        })
        if (res.status === 'SUCCESS') {
          self.bankName = res.bankName
          self.aadhaarNo = res.aadhaarNo
          self.vid = vid
          self.transactionTime = res.transactionTime
          self.transactions = res.transactions
          self.fetchTnxListStatus = res.status
          self.amount = res.amount
        } else {
          self.fetchTnxListStatus = res.status
          self.vid = vid
          self.cashWithdrawal = {
            transactionId: '',
            bankName: res.bankName,
            mobileNo: '',
            aadhaarNumber: res.aadhaarNo,
            amount: '0',
            tnxTime: '',
            message: res.failiureMessage,
            status: res.status,
            transferType: '',
            remittersAadhar: '',
            remittersVID: '',
            beneficiaryAadhar: '',
            nextActionRequest: '',
            rrnNo: '',
          }
        }
        return res
      } catch (err) {
        // Handle errors from the location check or the API call
        RootStore.message.handleError(err)
        throw err
      }
    }),
    // getMiniStatementApi: flow(function* getMiniStatementApi(
    //   aadhaarNumber: string,
    //   bankId: string,
    //   bankName: string,
    //   mobileNo: string,
    //   fingerPrintData: any,
    //   vid: any,
    //   consentDetails: any,
    //   authMode: any
    // ) {
    //   const request: any = getBalanceRequest(
    //     RootStore.agent.agentInfo,
    //     fingerPrintData,
    //     aadhaarNumber,
    //     bankId,
    //     bankName,
    //     mobileNo,
    //     vid,
    //     method.MINI_STATEMENT_TYPE,
    //     consentDetails,
    //   )
    //   request.secure.biometrics.type = authMode === 'FACE' ? 3 : 1;
    //   const res = yield executeTransaction(
    //     RootStore.agent.session,
    //     request,
    //     'mini_statement',
    //   ).catch((err: any) => {
    //     RootStore.message.handleError(err)
    //     throw err
    //   })
    //   if (res.status === 'SUCCESS') {
    //     self.bankName = res.bankName
    //     self.aadhaarNo = res.aadhaarNo
    //     self.vid = vid
    //     self.transactionTime = res.transactionTime
    //     self.transactions = res.transactions
    //     self.fetchTnxListStatus = res.status
    //     self.amount = res.amount
    //   } else {
    //     self.fetchTnxListStatus = res.status
    //     self.vid = vid
    //     self.cashWithdrawal = {
    //       transactionId: '',
    //       bankName: res.bankName,
    //       mobileNo: '',
    //       aadhaarNumber: res.aadhaarNo,
    //       amount: '0',
    //       tnxTime: '',
    //       message: res.failiureMessage,
    //       status: res.status,
    //       transferType: '',
    //       remittersAadhar: '',
    //       remittersVID: '',
    //       beneficiaryAadhar: '',
    //       nextActionRequest: '',
    //       rrnNo: '',
    //     }
    //   }

    //   return res
    // }),
    fetchParticularTransactionApi: flow(function* fetchParticularTransactionApi(tnxId: string) {
      try {
        const res = yield fetchParticularTransaction(RootStore.agent.session, getParticularTransactionRequest(tnxId))
        self.cashWithdrawal = res
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    fetchTransactionHistoryApi: flow(function* fetchTransactionHistoryApi() {
      try {
        const res = yield fetchTransactionHistory(
          RootStore.agent.session,
          getTransactionHistoryRequest(RootStore.agent.agentInfo.agentUserLoginId),
        )
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    updateTransactionForStatus(data: any) {
      const modifiedData = transactionStatusParser(data)
      self.cashWithdrawal = modifiedData
    },
    sendOTPToCustomerMobile: flow(function* sendOTPToCustomerMobile(mobileNo: string) {
      const generateOtpReq = getOtpRequest(mobileNo, '+91', 2, '18')
      const res = yield generateOtp(RootStore.agent.session, generateOtpReq).catch((err: any) => {
        console.log('ajhgaj', err)
        if (err?.data?.error?.code == '22413') {
          err.message = 'Please enter mobile no associated with Jio Payment Bank account.'
        }
        //RootStore.message.handleError(err)
        RootStore.message.showErrDialog(err?.message, 'NEGATIVE')
        throw err
      })
      return res
    }),
    validateCustomerOTP: flow(function* validateCustomerOTP(otp: string, mobileNo: string) {
      try {
        const req = getAuthenticateOtpForCustomer(otp, mobileNo)

        const res = yield authenticateOtp(RootStore.agent.session, req)
        self.session.userAccessToken = res.userAccessToken
        self.session.userRefreshToken = res.userRefreshToken
        self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
        self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
        self.session.userIdentifierToken = res.userIdentifierToken

        console.log('res', res)
        return res
      } catch (err) {
        //RootStore.message.handleError(err)
        RootStore.message.showErrDialog(err?.message, 'NEGATIVE')
        throw err
      }
    }),
    updateCustomerAccessToken: function updateCustomerAccessToken(res: any) {
      self.session.userAccessToken = res?.userAccessToken
      self.session.userRefreshToken = res?.userRefreshToken
      self.session.userIdentifierToken = res?.userIdentifierToken
    },

    sendOTPToAadhaar: flow(function* sendOTPToAadhaar(aadhaarNo: string, mobileNo: string) {
      const generateOtpReq = getAadhaarOtpRequest(aadhaarNo, mobileNo)
      const res = yield generateOtp(RootStore.agent.session, generateOtpReq).catch((err: any) => {
        //RootStore.message.handleError(err)
        RootStore.message.showErrDialog(err?.message, 'NEGATIVE')
        throw err
      })
      return res
    }),
    linkAadhharWithOtp: flow(function* linkAadhharWithOtp(aadhaarNo: string, mobileNo: string, otp: string) {
      console.log('inhghj')
      const linkAadhaarOtpRequest = getLinkAadhaarOtpRequest(aadhaarNo, mobileNo, otp)
      try {
        const res = yield linkAadhaarOtp(self.getCustomerToken(), linkAadhaarOtpRequest)
        console.log('res', res)
        return res
      } catch (err) {
        console.log('err', err)
        if (err?.code === '33607') {
          try {
            console.log('session expired')
            const customerUserSesion = yield refreshUserSession(self.getCustomerToken(), mobileNo)
            self.updateCustomerAccessToken(customerUserSesion)
            console.log('customerUserSesion', customerUserSesion)
            const res = yield linkAadhaarOtp(self.getCustomerToken(), linkAadhaarOtpRequest)
            console.log('customerUserSesion res', res)
            //RootStore.message.setMessage("Aadhaar card linked with mobile no. sucessfully.","POSITIVE")
            return res
          } catch (err) {
            // RootStore.message.handleError(err)
            RootStore.message.showErrDialog(err?.message, err.code === '50001' ? 'NEGATIVE' : 'LINK_ADDHAAR_ERROR')
            throw err
          }
        } else {
          //RootStore.message.handleError(err)
          RootStore.message.showErrDialog(err?.message, err.code === '50001' ? 'NEGATIVE' : 'LINK_ADDHAAR_ERROR')
          throw err
        }
      }
    }),
    generateCustomerOtp: flow(function* generateCustomerOtp(mobileNo: string) {
      try {
        yield generateOTP(mobileNo, RootStore.agent.session)
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    validateCustomerOtp: flow(function* validateCustomerOtp(otp: string, mobileNo: string) {
      try {
        const response = yield validateOtpApi(otp, mobileNo, RootStore.agent.session)
        const session = response?.data
        self.remittanceUserId = session?.remittanceUserId
        RootStore?.moneyTransferSession?.updateUserIdToken(session?.session?.userIdentifierToken)
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
  }))
  .views((self) => ({
    getCustomerToken(): any {
      return {
        ...RootStore.agent.session,
        userAccessToken: self.session.userAccessToken,
        userRefreshToken: self.session.userRefreshToken,
        userAccessTokenExpiry: self.session.userAccessTokenExpiry,
        userRefreshTokenExpiry: self.session.userRefreshTokenExpiry,
        userIdentifierToken: self.session.userIdentifierToken,
      }
    },
  }))

const CustomerData = Customer.create({})

export { Customer, CustomerData }

export interface FundTransferApiProps {
  aadhaarNumber: string
  bankId: string
  bankName: string
  mobileNo: string
  amount: string
  beneficieryBankName: string
  beneficieryBankId: string
  beneficieryAadhaar: string
  fingerprintData: any
  beneficieryVid: any
  vid: any
  consentDetails: any
  authMode: any
}
